var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col-md-4 left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.taxes")) +
                  " > " +
                  _vm._s(this.$route.query.tax_name) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8 right" }, [
            _vm.tax !== null
              ? _c("div", { staticClass: "action" }, [
                  _vm.showOptionButton
                    ? _c("div", { staticClass: "dropdown item" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn no-bg dropdown-toggle text-secondary shake",
                            attrs: {
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-haspopup": "true",
                              "aria-expanded": "false"
                            }
                          },
                          [
                            _c("i", { staticClass: "fas fa-cog" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(_vm.$t("button.options")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "dropdown-menu dropdown-menu-right" },
                          [
                            _vm.hasRoleDelete
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.openConfirmdeleteModal()
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-trash text-danger"
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "text-danger" }, [
                                      _vm._v(_vm._s(_vm.$t("button.delete")))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          _vm.ready
            ? [
                _c("section", { staticClass: "choose-type" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.selecttype") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "row wrapper" }, [
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c(
                                  "vs-radio",
                                  {
                                    staticStyle: {
                                      float: "left",
                                      padding: "0"
                                    },
                                    attrs: {
                                      vsValue: _vm.TAX_FORM_TYPE.TAX,
                                      disabled: true,
                                      color: "#A3CA76"
                                    },
                                    model: {
                                      value: _vm.form.formType,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "formType", $$v)
                                      },
                                      expression: "form.formType"
                                    }
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "apps.product.message.typetax"
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-check-label",
                                staticStyle: { "margin-left": "25px" }
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "apps.product.message.typetaxdetail"
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ])
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c(
                                  "vs-radio",
                                  {
                                    staticStyle: {
                                      float: "left",
                                      padding: "0"
                                    },
                                    attrs: {
                                      vsValue: _vm.TAX_FORM_TYPE.SERVICE_CHARGE,
                                      disabled: true,
                                      color: "#A3CA76"
                                    },
                                    model: {
                                      value: _vm.form.formType,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "formType", $$v)
                                      },
                                      expression: "form.formType"
                                    }
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "apps.product.message.typeservicecharge"
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-check-label",
                                staticStyle: { "margin-left": "25px" }
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "apps.product.message.typeservicechargedetail"
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ])
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c(
                                  "vs-radio",
                                  {
                                    staticStyle: {
                                      float: "left",
                                      padding: "0"
                                    },
                                    attrs: {
                                      vsValue: _vm.TAX_FORM_TYPE.FEE,
                                      disabled: true,
                                      color: "#A3CA76"
                                    },
                                    model: {
                                      value: _vm.form.formType,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "formType", $$v)
                                      },
                                      expression: "form.formType"
                                    }
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "apps.product.message.typefee"
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-check-label",
                                staticStyle: { "margin-left": "25px" }
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "apps.product.message.typefeedetail"
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ])
                              ]
                            )
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.general") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6 mb-mobile-2" }, [
                          _c("div", { staticClass: "form-group row mb-0" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.tax_name")) + " *"
                                )
                              ]),
                              _vm._v(" "),
                              _vm.tax.deletable
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.$v.form.tax_name.$model,
                                        expression: "$v.form.tax_name.$model"
                                      }
                                    ],
                                    ref: "tax_name",
                                    class: [
                                      "form-control tax-name",
                                      {
                                        "is-invalid":
                                          _vm.$v.form.tax_name.$error
                                      }
                                    ],
                                    attrs: {
                                      disabled: _vm.disabledForm,
                                      type: "text"
                                    },
                                    domProps: {
                                      value: _vm.$v.form.tax_name.$model
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.$v.form.tax_name,
                                          "$model",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                : _c("input", {
                                    class: ["form-control tax-name"],
                                    attrs: { disabled: true, type: "text" },
                                    domProps: {
                                      value: _vm.getMasterDataText(
                                        _vm.tax.tax_name,
                                        _vm.$t
                                      )
                                    }
                                  })
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        [_vm.TAX_FORM_TYPE.TAX].includes(_vm.form.formType)
                          ? _c("div", { staticClass: "col-md-6" }, [
                              _c(
                                "div",
                                { staticClass: "form-group row mb-0" },
                                [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("message.tax_amount")) +
                                          " *"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "input-group" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.form.amount,
                                            expression: "form.amount"
                                          }
                                        ],
                                        ref: "amount",
                                        staticClass:
                                          "form-control text-right number-only text-select-all",
                                        staticStyle: { "border-right": "0" },
                                        attrs: {
                                          disabled: _vm.disabledForm,
                                          type: "text"
                                        },
                                        domProps: { value: _vm.form.amount },
                                        on: {
                                          keypress: _vm.numberOnly,
                                          keyup: function($event) {
                                            _vm.form.amount = _vm.setToValidNumber(
                                              _vm.form.amount
                                            )
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.form,
                                              "amount",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn dropdown-toggle",
                                              staticStyle: {
                                                border: "1px solid #ced4da"
                                              },
                                              attrs: {
                                                disabled:
                                                  _vm.disabledForm ||
                                                  _vm.tax.deletable === false,
                                                type: "button",
                                                "data-toggle": "dropdown",
                                                "aria-haspopup": "true",
                                                "aria-expanded": "false"
                                              }
                                            },
                                            [
                                              _vm.form.type == "exclude"
                                                ? [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.tax_exclude"
                                                          )
                                                        ) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.form.type == "include"
                                                ? [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.tax_include"
                                                          )
                                                        ) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-menu" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.form.type = "exclude"
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.tax_exclude"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.form.type = "include"
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.tax_include"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ])
                          : _c("div", { staticClass: "col-md-6" }, [
                              _c(
                                "div",
                                { staticClass: "form-group row mb-0" },
                                [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("message.tax_amount")) +
                                          " *"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.form.amount,
                                            expression: "form.amount"
                                          }
                                        ],
                                        ref: "amount",
                                        staticClass:
                                          "form-control text-right number-only text-select-all",
                                        attrs: {
                                          disabled: _vm.disabledForm,
                                          type: "text"
                                        },
                                        domProps: { value: _vm.form.amount },
                                        on: {
                                          keypress: _vm.numberOnly,
                                          keyup: function($event) {
                                            _vm.form.amount = _vm.setToValidNumber(
                                              _vm.form.amount
                                            )
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.form,
                                              "amount",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  ])
                                ]
                              )
                            ])
                      ]),
                      _vm._v(" "),
                      [_vm.TAX_FORM_TYPE.FEE].includes(_vm.form.formType)
                        ? _c("div", { staticClass: "row mt-3" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _c("label", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "apps.product.message.calculatedfrom"
                                      )
                                    ) +
                                    " *\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-row" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.form.feeCalcType.$model,
                                          expression:
                                            "$v.form.feeCalcType.$model"
                                        }
                                      ],
                                      class: [
                                        "custom-select form-control",
                                        {
                                          "is-invalid":
                                            _vm.$v.form.feeCalcType.$error
                                        }
                                      ],
                                      attrs: { disabled: _vm.disabledForm },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.$v.form.feeCalcType,
                                            "$model",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: null } },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t("placeholder.select")
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.FEE_CALC_TYPE.NET
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "apps.product.message.calctypenet"
                                                )
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.FEE_CALC_TYPE.CUSTOM
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "apps.product.message.calctypecustom"
                                                )
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.form.feeCalcType ===
                                _vm.FEE_CALC_TYPE.CUSTOM
                                  ? _c("div", { staticClass: "col-6" }, [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.$v.form.feeCalcTaxId.$model,
                                              expression:
                                                "$v.form.feeCalcTaxId.$model"
                                            }
                                          ],
                                          class: [
                                            "custom-select form-control",
                                            {
                                              "is-invalid":
                                                _vm.$v.form.feeCalcTaxId.$error
                                            }
                                          ],
                                          attrs: { disabled: _vm.disabledForm },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.$v.form.feeCalcTaxId,
                                                "$model",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t("placeholder.select")
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.taxesNames, function(
                                            tax,
                                            index
                                          ) {
                                            return _c(
                                              "option",
                                              {
                                                key: index,
                                                domProps: { value: tax.id }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(tax.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          })
                                        ],
                                        2
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "mt-3" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("section-header", {
                          attrs: {
                            title: _vm.$t(
                              "apps.product.message.advancedoptions"
                            )
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c("label", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("apps.product.message.group")) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-lg-6" },
                          [
                            _c("vue-bootstrap-autocomplete", {
                              attrs: {
                                data: _vm.getTaxesGroupNames,
                                minMatchingChars: 1,
                                showOnFocus: true,
                                disabled: _vm.disabledForm
                              },
                              model: {
                                value: _vm.form.groupName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "groupName", $$v)
                                },
                                expression: "form.groupName"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 mt-2" },
                      [
                        _c("BaseCheckbox", {
                          attrs: {
                            disabled: true,
                            label: _vm.$t("apps.product.message.taxforsale")
                          },
                          model: {
                            value: _vm.form.isForSale,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "isForSale", $$v)
                            },
                            expression: "form.isForSale"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    [_vm.TAX_FORM_TYPE.TAX].includes(_vm.form.formType)
                      ? _c(
                          "div",
                          { staticClass: "col-12 mt-2" },
                          [
                            _c("BaseCheckbox", {
                              attrs: {
                                label: _vm.$t(
                                  "apps.product.message.taxforpurchase"
                                ),
                                disabled: _vm.disabledForm
                              },
                              model: {
                                value: _vm.form.isForPurchase,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "isForPurchase", $$v)
                                },
                                expression: "form.isForPurchase"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    [_vm.TAX_FORM_TYPE.TAX].includes(_vm.form.formType)
                      ? _c(
                          "div",
                          { staticClass: "col-12 mt-2" },
                          [
                            _c("BaseCheckbox", {
                              attrs: {
                                label: _vm.$t(
                                  "apps.product.message.taxforexpense"
                                )
                              },
                              model: {
                                value: _vm.form.isForExpense,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "isForExpense", $$v)
                                },
                                expression: "form.isForExpense"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    [_vm.TAX_FORM_TYPE.FEE].includes(_vm.form.formType)
                      ? _c(
                          "div",
                          { staticClass: "col-12 mt-2" },
                          [
                            _c("BaseCheckbox", {
                              attrs: {
                                label: _vm.$t(
                                  "apps.product.message.showfeeresult"
                                ),
                                disabled: _vm.disabledForm
                              },
                              model: {
                                value: _vm.form.isDisplayResult,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "isDisplayResult", $$v)
                                },
                                expression: "form.isDisplayResult"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass: "assign-items mt-3",
                    staticStyle: { "margin-bottom": "20px" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-md-12 no-padding" },
                      [
                        _c("section-header", {
                          attrs: { title: _vm.$t("message.assignitems") }
                        }),
                        _vm._v(" "),
                        !_vm.products.length
                          ? _c("BaseNotFoundData", {
                              attrs: {
                                title: _vm.$t(
                                  "apps.pos.message.notfoundproduct"
                                ),
                                detail: _vm.$t("apps.pos.message.createproduct")
                              }
                            })
                          : _c("base-assign-items", {
                              attrs: {
                                items: _vm.form.assignProductItems,
                                disabled: _vm.disabledForm
                              },
                              model: {
                                value: _vm.form.assignProductIds,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "assignProductIds", $$v)
                                },
                                expression: "form.assignProductIds"
                              }
                            })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("section", { staticClass: "mt-4" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 mt-2" },
                      [
                        _c("BaseCheckbox", {
                          attrs: {
                            label: _vm.form.isActive
                              ? _vm.$t("message.enabled")
                              : _vm.$t("message.disabled"),
                            disabled: _vm.disabledForm
                          },
                          model: {
                            value: _vm.form.isActive,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "isActive", $$v)
                            },
                            expression: "form.isActive"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "mt-4" }, [
                  _c("div", { staticClass: "col-md-12 no-padding" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("message.applyitemtoapps", {
                            item: _vm.$t("sidebar.taxes")
                          })
                        ) +
                        "\n          "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.treesoft.io/th/manual/product#tax",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("button.learnmore")) +
                            "\n            "
                        ),
                        _c("i", { staticClass: "fas fa-external-link-alt" })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                !_vm.disabledForm
                  ? _c("section", { staticClass: "action-bar" }, [
                      !_vm.$store.state.app.loading
                        ? _c("div", { staticClass: "col-md-12 text-right" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-web",
                                on: {
                                  click: function($event) {
                                    return _vm.save()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("button.save")))]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$store.state.app.loading
                        ? _c("div", { staticClass: "col-md-12 text-right" }, [
                            _vm._m(0)
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "confirmdeleteModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "pricesModalTitle",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog ", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-header",
                    staticStyle: { "border-bottom": "none" }
                  },
                  [
                    _vm.tax
                      ? _c("h5", { staticClass: "modal-title" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("message.areyousuretodeletethis")) +
                              "\n          "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.$store.state.app.loading
                      ? _c(
                          "button",
                          {
                            staticClass: "close",
                            attrs: { type: "button", "aria-label": "Close" },
                            on: {
                              click: function($event) {
                                return _vm.closeConfirmdeleteModal()
                              }
                            }
                          },
                          [
                            _c("span", { attrs: { "aria-hidden": "true" } }, [
                              _vm._v("×")
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                !_vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.closeConfirmdeleteModal()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-danger",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.del()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.delete")))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button", disabled: "" }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _vm._m(1)
                    ])
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      }),
      _vm._v(" "),
      _c("BaseAlertModal", {
        attrs: {
          id: _vm.DELETE_DEFAULT_TAX_MODAL,
          headerText: _vm.$t("message.notbeabletodeletedefaultdata")
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-danger",
        attrs: { type: "button", disabled: "" }
      },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0153f0ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0153f0ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/accounts/tax/Edit.vue
// module id = null
// module chunks = 